import React from 'react';

class OutsideSubtitle extends React.Component {
  shouldComponentUpdate = (nextProps, nextState) => {
    return nextProps.currentSubtitle !== this.props.currentSubtitle
    || nextProps.currentSubtitleMode !== this.props.currentSubtitleMode;
  }
  render = () => {
    let subtitle = this.props.currentSubtitle;
    const subtitleMode = this.props.currentSubtitleMode;
    if (subtitleMode !== 'outside') return (<div></div>);
    if (subtitle === '' || subtitle === undefined) subtitle = '&nbsp;';
    return (<div id="outside-subtitle" dangerouslySetInnerHTML={{__html: subtitle}}></div>);
  };
}

export default OutsideSubtitle;



// WEBPACK FOOTER //
// ./src/components/OutsideSubtitle.js